import { useEffect, useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import SendEmail from '../../../../components/SendEmail';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchInvoiceDetails, sendEmail } from '../../../../../services/invoices';

const InvoiceSendEmails = () => {
	const params = useParams();
	const { id } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [invoiceDetails, setInvoiceDetails] = useState(null);
	const [emailFormData, setEmailFormData] = useState({
		from: '',
		to: [],
		subject: '',
		body: '',
		isAttachment: true,
	});

	async function handleSend(formData) {
		try {
			await sendEmail(id, formData);
			toast.success('Email Sent Successfully.');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			throw error;
		}
	}

	function handleClose() {
		navigate(`/user/${suburl}/invoices`);
	}

	async function handleFetchInvoiceDetails() {
		try {
			setIsLoading(true);
			const { invoice } = await fetchInvoiceDetails({ ids: [id] });
			setInvoiceDetails(invoice);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchInvoiceDetails();
		}
	}, [id]);

	useEffect(() => {
		if (invoiceDetails && userInfo) {
			const { invoice_number, customer, doctor } = invoiceDetails;

			var customerEmailList = [];
			var customerToSendEmailList = [];
			if (customer?.email) {
				customerEmailList.push(customer.email);
				customerToSendEmailList.push(customer.email);
			}
			setEmailFormData((prev) => ({
				...prev,
				to: customerToSendEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				subject: `Invoice from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name} (Invoice number #: ${invoice_number})`,
			}));
			setToEmails(customerEmailList);
		}
	}, [invoiceDetails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}

	return (
		<SendEmail
			audience="customer"
			pdfName="Invoice"
			pdfId={`${invoiceDetails?.invoice_number}`}
			toEmails={toEmails}
			formData={emailFormData}
			handleSend={handleSend}
			handleClose={handleClose}
			isDropdownListShow={false}
		/>
	);
};

export default InvoiceSendEmails;
